module.exports = __webpack_public_path__ + "img/fushimi-HP-004.139d28a4.jpg";